export class Note {
  $key: string;
  created_at: Date;
  updated_at: Date;
  subject_uid: string;
  text: string;
}
